import React, { useState, memo } from 'react';
import { useSlate } from 'slate-react';
import classnames from 'classnames';
import getYoutubeID from 'get-youtube-id';

import Modal from 'components/Modal';
import Icon from 'components/Misc/Icon';
import { Input, Button } from 'components/Misc/Form';

// Youtube's button component
// @format: string | format's type
// @icon: string | icon's type
const Youtube = memo(() => {
	// Cache link's data
	const [data, setData] = useState({
		href: '',
		path: ''
	});

	// Cache link's container visibility
	const [visible, setVisible] = useState(false);

	// Get current editor
	const editor = useSlate();

	// Check if link is active
	const isActive = editor.isElementActive('youtube');

	// Check if link is disabled
	const isDisabled =  editor.isYoutubeDisabled();

	// Generate classnames
	const cls = classnames(
		isActive && 'bg-neutral-100 dark:bg-neutral-700',
		isDisabled
			? 'text-neutral-400 dark:text-neutral-700'
			: 'text-neutral-800 dark:text-white',
		'w-9 h-9 leading-9 rounded-lg text-xl text-center cursor-pointer transition-colors'
	);

	// Handle add link button click
	// @event: object | default onClick event
	const onInsert = event => {
		event.preventDefault();

		// Create link element in editor's selection
		editor.insertYoutube({
			...data,
			href: getYoutubeID(data.href)
		});

		// Hide link's toolbar
		handleModal();
	};

	// Handles highlight's button click
	const onClick = () => {
		// Prevent link insertion if no selection
		if (!editor.selection) return;

		// Show link's toolbar
		setVisible(v => !v);

		// Store link's data
		setData(prev => ({
			...prev,
			...editor.prepareYoutube()
		}));
	};

	// Handles link's data change
	// @event: object | onChange event
	const onChange = ({ name, value }) => {
		setData(prev => ({
			...prev,
			[name]: value
		}));
	};

	// Handles click outside of highlight's container
	const handleModal = () => {
		// Hide modal
		setVisible(false);

		// Reset link's state
		setData(prev => ({
			...prev,
			href: '',
			path: null
		}));
	};

	return (
		<>
			{/* Formater's button */}
			<Icon
				icon="youtube_activity"
				className={cls}
				onClick={onClick}
				disabled={isDisabled}
			/>

			{/* Additional control menu */}
			<Modal title="Ievietot YouTube video" visible={visible} handleModal={handleModal}>
				<div className="space-y-4">
					<Input
						type="text"
						name="href"
						label="Saite"
						value={data.href}
						onChange={onChange}
					/>

					<div className="flex justify-end">
						<Button
							theme="success"
							value="Ievietot"
							icon="add"
							onClick={onInsert}
						/>
					</div>
				</div>
			</Modal>
		</>
	);
});

export default Youtube;
